import angular from 'angular';
import './style.scss';

export default angular
  .module('components.noLenderImage', [])
  .component('noLenderImage', {
    template: `<div class="no-lender-image"></div>`,
  }).name;
